import "./App.css";
import React, { useEffect, useState } from "react";
import Main from "./components/main/Main";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { Routes, Route } from "react-router-dom";

import "@aws-amplify/ui-react/styles.css";
import { ErrorHandlerProvider } from "./components/main/body/common/context/ErrorStore";
import { NotificationToastProvider } from "./components/main/body/common/context/NotificationToastContext";
import { LoaderProvider } from "./components/main/context/LoaderContext";
import { UserProvider, useUser } from "./components/main/context/User/UserContext";
import { HMSRoomProvider } from "@100mslive/react-sdk";
import { SidebarProvider } from "./components/main/context/Sidebar/SidebarContext";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { InAppNotificationProvider } from "./components/main/context/InAppNotificationContext/InAppNotificationContext";
import { NewEmergencyProvider } from "./components/main/context/MedicalListContext/MedicalListContext";
import { ReportProvider } from "./components/main/context/IndicatorContext/IndicatorContext";
import { InternetStatusNotificationProvider } from "./components/main/context/User/NotificationContext";
import * as Sentry from '@sentry/react';
import { Auth } from "aws-amplify";
import { observer } from "mobx-react";
import { useStore } from "./Hooks/useStore";
import { CheckForMultiLogin, generateDeviceId, logoutSession } from "./util/CheckMultiLogin/CheckMultiLogin";
import SameULoginModal from "./util/CheckMultiLogin/SameULoginModal";
import usersService from "./components/main/body/screens/IAM/Users/users.service";
import UserRestrictLoginModal from "./util/CheckMultiLogin/UserRestrictLoginModal";
import RoleChoose from "./util/CheckMultiLogin/RoleChoose";
import Header from "./components/main/body/screens/Login/Components/Header/Header";
import Content from "./components/main/body/screens/Login/Components/Content/Content";
import Footer from "./components/main/body/screens/Login/Components/Footer/Footer";
import { Autoupdateenum } from './enums';
import {isEmpty} from "./util/Helper";
import {API, graphqlOperation} from 'aws-amplify';
//import { disableShortcuts } from "./util/Helper";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import OnlineForm from "./components/main/body/screens/OnlineForm/OnlineForm";
import Login from "./components/routes/Login";
import MedicalEmergencyService from "./services/medical-emergency/medical-emergency.service";
import ViewDetailedForm from "./components/main/body/screens/OnlineForm/ViewDetailedForm";



Chart.register(CategoryScale);

Sentry.init({
  environment: process.env.NODE_ENV === "development" ? "development" : process.env.REACT_APP_ENV,
  dsn: "https://6bc4438f4b208f55a2c1cf0a022d6378@o4506523161001984.ingest.sentry.io/4506534446039040",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (module.hot) {
  module.hot.accept();
}




//config
const signUpConfig = {
  username: {
    placeholder: "Username",
    isRequired: true,
    displayOrder: 1,
    type: "string",
  },
  password: {
    placeholder: "Password",
    isRequired: true,
    displayOrder: 2,
    type: "password",
  },
  email: {
    placeholder: "Email",
    isRequired: true,
    displayOrder: 3,
    type: "email",
  },
  name: {
    placeholder: "Name",
    isRequired: true,
    displayOrder: 4,
    type: "string",
  },
  family_name: {
    placeholder: "Last Name",
    isRequired: true,
    displayOrder: 5,
    type: "string",
  },
};

mapboxgl.accessToken =
  "pk.eyJ1IjoibXVzMm0xNzA1IiwiYSI6ImNsYThiMjlrYzAwdHozcnBncDRjZHhjbXcifQ.FqApaUa-qs065A8A4p51CA";


  //test
let appSyncSubscription;


  export  const subscribeToTopic = async (flightId,rootStore) => {

   
   
    if (isEmpty(flightId)) {
      console.log("Flight id Can't be empty");
      return;
    }
    console.log(
      flightId,
      'flightId',
    );
    const subscribeToTopicSubscription = `
  subscription MySubscription($flightId: String!) {
    onCreateTblAppAutoRefresh(flightId: $flightId) {
      emergencyId
    flightId
    value
    }
  }`;

    try {
      appSyncSubscription = API.graphql(
        graphqlOperation(subscribeToTopicSubscription, {
          flightId: flightId,
        }),
        // @ts-ignore
      ).subscribe({
        // @ts-ignoresendDataToTopic(RootStore.crewStore.medicalEmergency.id,autoUpdateEnum.FileUpload);
        next: async data => {
          console.log(data.value.data, 'data.value.data');
          switch (data.value.data.onCreateTblAppAutoRefresh.value) {
            case Autoupdateenum.Emergency:
              console.log("case1"+Autoupdateenum.Emergency);
              rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
              break;

            case Autoupdateenum.MedicalKit:
              console.log("case2"+Autoupdateenum.MedicalKit);
              rootStore.emsStore.handleMedicalKitRefresh();
              break;

            case Autoupdateenum.List:
              console.log("case3"+Autoupdateenum.List)
             rootStore.emsStore.handleNewEmergency();
              break;

            case Autoupdateenum.FileUpload:

            console.log("case4"+Autoupdateenum.FileUpload)
            rootStore.emsStore.handleReport();
              break;
            case Autoupdateenum.FlightStatus:
              console.log("case5"+Autoupdateenum.FlightStatus);
              rootStore.emsStore.handlePageRefreshCount(rootStore.emsStore.getpageRefreshCount + 1);
              break;

            case Autoupdateenum.VoiceCall:
              console.log("case6"+Autoupdateenum.VoiceCall);
              let userAttribute2 = await Auth.currentAuthenticatedUser();
              console.log("voice call userAttribute2", userAttribute2);
              let [emergencyId, username, userType] = data.value.data.onCreateTblAppAutoRefresh.emergencyId.split("#");
              console.log("voice call emergencyId", emergencyId);
              console.log("voice call username", username);
              console.log("voice call userType", userType);
              if (emergencyId) {
                (async() => {
                  try {
                    const medicalEmergencyFromAPI = await MedicalEmergencyService.getMedicalEmergency(emergencyId);
                    console.log("voice call medicalEmergencyFromAPI", medicalEmergencyFromAPI);
                    let assignedEmsName = medicalEmergencyFromAPI.assignedEms;
                    console.log("voice call assignedEmsName", assignedEmsName);
                    if (userAttribute2.username == assignedEmsName && userType != "ems") {
                      console.log("voice call ringtone");
                      rootStore.callingStore.showNotification();
                      rootStore.callingStore.handleCrewname(username);
                      rootStore.callingStore.handleShow(true);
                      rootStore.callingStore.handleEmergencyId(data.value.data.onCreateTblAppAutoRefresh.emergencyId);
                      rootStore.callingStore.handleFlightId(data.value.data.onCreateTblAppAutoRefresh.flightId);
                    }
                    
                  } catch(error) {
                    console.log("Error in get medical emergency", error);
                  }
                })()
              }
              break;
            case Autoupdateenum.VoiceCallEnded:
              console.log("voice call end now");
              let childWindow = rootStore.callingStore.getChildWindowRef;
              console.log("childWindow",childWindow);
               if (childWindow) {
                childWindow.close();
                rootStore.callingStore.handleChildWindowRef(null);
               }
               else
               {
                rootStore.callingStore.setPauseDecline(true);
               }
               console.log("try to close popup");
              //  rootStore.callingStore.resetNotification();
              //  rootStore.callingStore.handleInComingCall(false);
              
               console.log("getShow value after setPauseDecline:", rootStore.callingStore.setPauseDecline);

              break;
            default:
              break;
          }
        },
        // @ts-ignore
        error: error => console.warn(JSON.stringify(error, null, 2)),
      });
    } catch (error) {
     // alert("sdfdfd");
      console.log(error);
    }
  };
  export const unsubscribeToTopic = async (rootStore) => {
    // @ts-ignore
    if (appSyncSubscription?.unsubscribe) {
      // @ts-ignore
      appSyncSubscription?.unsubscribe();
      rootStore.emsStore.resetFlightsubscribe();
    }
  };

  export const unsubscribeToTopicnew = async (rootStore) => {
    // @ts-ignore
    if (appSyncSubscription?.unsubscribe) {
      // @ts-ignore
      appSyncSubscription?.unsubscribe();
     
    }
  };
 export const sendDataToTopic = async (emergencyId,flightId, value) => {
    await deleteDataToTopic(flightId);
    const input = {
      emergencyId: emergencyId,
      flightId: flightId,
      value: value,
    };
    console.log(input, 'topicData');

    const pubSubPushToTopic = `
    mutation CreateAutoRefresh($emergencyId: String!, $flightId: String!, $value: String!) {
      createTblAppAutoRefresh(input: { emergencyId: $emergencyId, flightId: $flightId, value: $value }) {
        emergencyId
        flightId
        value
      }
    }`;
    try {
      const res = await API.graphql(graphqlOperation(pubSubPushToTopic, input));
      console.log(res, 'res.data.listTblChatNotifications.items');
      setTimeout(() => {
         deleteDataToTopic(flightId);
     }, 5000);
    } catch (error) {
      // @ts-ignore
      if (isEmpty(error?.data?.createTblAppAutoRefresh)) {
       deleteDataToTopic(flightId);
      }
      console.log(
        // @ts-ignore
        JSON.stringify(error?.data?.createTblAppAutoRefresh, null, 2),
        'res.data.listTblChatNotifications.items',
      );
    }
  };
  export const  deleteDataToTopic = async (flightId) => {
    const input = {
      flightId: flightId,
    };
    console.log(input, 'topicData');

    const pubSubPushToDeleteTopic = `
    mutation deleteAutoRefresh($flightId: String!) {
      deleteTblAppAutoRefresh(input: {flightId: $flightId}) {
        flightId
      }
    }`;
    try {
      const res = await API.graphql(
        graphqlOperation(pubSubPushToDeleteTopic, input),
      );
      console.log(res, 'res.data.deleteDataToTopic');
    } catch (error) {
      console.log(JSON.stringify(error, null, 2), 'res.data.deleteDataToTopic');
    }
  };


function App() {
  const { rootStore } = useStore();
  const {user, setUser} = useUser();
  const autoUpdateEnum = Autoupdateenum.Emergency;

  useEffect(() => {
    // Non-sensitive cookie (safe for frontend)
    document.cookie = `app_initialized=true; Secure=true; SameSite=Lax; path=/; max-age=86400`;
  
    // For authenticated users (better alternatives below)
    if (rootStore.userStore.getSession !== "") {
      document.cookie = `user_session_active=true; Secure=true; SameSite=Strict; path=/; max-age=${34 * 3600}`;
      
      // Preferred: Use Amplify's session handling instead
      Auth.currentAuthenticatedUser().then(user => {
        console.log("Session managed by Amplify", user);
      });
    }
  }, [rootStore.userStore.getSession]);

  useEffect(() => {
    token();
  },[rootStore.userStore.getSession, rootStore.userStore.getPageRefresh]);

  const token = async () => {
    const session = await Auth.currentSession();
    const accessToken = session.getAccessToken().getJwtToken();
    rootStore.userStore.setSession(accessToken);
    console.log("accessToken in index", accessToken);
  }

  useEffect(() => {
    console.log("process.env.REACT_APP_ENV", process.env.REACT_APP_ENV);
  },[]);


  return (
    <>
    {
    rootStore.userStore.getSession==""
      ?
      <div>
            <Routes>
              <Route path="onboardingGuide" element={<OnlineForm />} />
              <Route path="/" element={<Login />} />
              <Route path="verifyForm/:formId" element={<ViewDetailedForm />} />
              <Route path="*" element={
                <div className='skali-home-page'>
                  <div className='row'>
                      <div className='w-100'>
                          <h1 style={{color:'#FFFFFF', textAlign:'center'}}>Unauthorized access</h1>
                      </div>
                  </div>
              </div>
              } />
            </Routes>
      </div>
    :
    <NewEmergencyProvider>
      <ReportProvider>
      <InternetStatusNotificationProvider>
    <InAppNotificationProvider>
      <NotificationToastProvider>
        <ErrorHandlerProvider>
          <LoaderProvider>
            <UserProvider>
              <HMSRoomProvider>
                <SidebarProvider>
                  <Main />
                </SidebarProvider>
              </HMSRoomProvider>
            </UserProvider>
          </LoaderProvider>
        </ErrorHandlerProvider>
      </NotificationToastProvider>
    </InAppNotificationProvider>
    </InternetStatusNotificationProvider>
      </ReportProvider>
    </NewEmergencyProvider>
    }
    </>
  );
}

export default observer(App);
